var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-scrollbar',{staticClass:"ls-layout ls-scrollbar"},[_c('div',{staticClass:"ls-view"},[_c('perm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }